'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _querystring = require('querystring');

var _querystring2 = _interopRequireDefault(_querystring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var queryParamBlackList = ['email', 'name', 'firstName', 'lastName', 'phone'];

exports.default = function (url) {
  var parsed = new URL(url);
  var query = parsed.search;
  if (query && query.length > 0) {
    var queryParams = _querystring2.default.parse(parsed.search.substr(1));
    query = '?' + _querystring2.default.stringify(Object.keys(queryParams).map(function (param) {
      return queryParamBlackList.indexOf(param) > -1 ? [param, '***'] : [param, queryParams[param]];
    }).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          param = _ref2[0],
          val = _ref2[1];

      return _defineProperty({}, param, val);
    }).reduce(function (l, r) {
      return Object.assign({}, l, r);
    }, {}));
  }
  parsed.search = query;
  return parsed.href;
};


// WEBPACK FOOTER //
// ./node_modules/@rategravity/frontend/modules/mask-querystring.js